export function createErrorNotice(messageText) {
  const messageContainer = document.querySelector("#payment-message")

  messageContainer.classList.remove("hidden")
  messageContainer.textContent = messageText

  setTimeout(function () {
    messageContainer.classList.add("hidden")
    messageContainer.textContent = ""
  }, 4000)
}

export function setLoading(isLoading) {
  let button = document.querySelector("#submit")

  if (isLoading) {
    button.disabled = true
    button.innerHTML = `<span class="with-icon gap-2.5 type-button"> Saving... </span>`
  } else {
    button.disabled = false
    button.innerHTML = `<span class="with-icon gap-2.5 type-button"> Save </span>`
  }
}
